var _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "RU - Russian Federation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2492_12253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    y: 0.5,
    width: 25,
    height: 18,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2492_12253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contents"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5V18.5H25V0.5H0Z",
    fill: "#3D58DB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2492_12253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "background_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5V18.5H25V0.5H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2492_12253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "top",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5V6.5H25V0.5H0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.5V18.5H25V12.5H0Z",
    fill: "#C51918"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.5437f8edb52bac9eec85f058cae96581.svg";
export { ForwardRef as ReactComponent };